import { makeAutoObservable } from 'mobx';
import SafeguardModalDelegate from 'store/general/safeguardModalDelegate';
import EnrollmentPeriodModule from 'store/modules/enrollment/enrollmentPeriodModule';

interface ConstructorParams {
  onSaveChanges: () => Promise<void>;
  onNoSavingExit: () => void;
  isStepCompleted: boolean;
  enrollmentPeriodModule: EnrollmentPeriodModule;
}

export class EnrollmentHeaderSafeguardDelegate {
  public saveChangesModalDelegate;
  public noSavingExitModalDelegate;
  private _isStepCompleted = false;
  private _onBackButtonStrategy;
  private _enrollmentPeriodModule: EnrollmentPeriodModule;

  public get isPeriodNotEditable(): boolean {
    return this._enrollmentPeriodModule.enrollmentPeriod.id ? this._enrollmentPeriodModule.isEnrollmentImmutable : true;
  }

  public get isStepCompleted(): boolean {
    return this._isStepCompleted;
  }

  public setIsStepCompleted(value: boolean): void {
    this._isStepCompleted = value;
  }

  public onBackButtonStrategy(): void {
    if (this.isPeriodNotEditable) {
      this._onBackButtonStrategy();
    } else if (this._isStepCompleted) {
      this.noSavingExitModalDelegate.open();
    } else {
      this.saveChangesModalDelegate.open();
    }
  }

  constructor({ onSaveChanges, onNoSavingExit, isStepCompleted, enrollmentPeriodModule }: ConstructorParams) {
    this._isStepCompleted = isStepCompleted;
    this._onBackButtonStrategy = onNoSavingExit;
    this._enrollmentPeriodModule = enrollmentPeriodModule;

    this.saveChangesModalDelegate = new SafeguardModalDelegate(
      () => {
        return onSaveChanges();
      },
      () => {
        return onNoSavingExit();
      },
    );
    this.noSavingExitModalDelegate = new SafeguardModalDelegate(() => {
      return onNoSavingExit();
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }
}
